var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.54,5.88,8.11.45a1.61,1.61,0,0,0-2.22,0L.46,5.88A1.55,1.55,0,0,0,0,7,1.53,1.53,0,0,0,.46,8.1l5.43,5.43a1.57,1.57,0,0,0,2.22,0L13.54,8.1A1.53,1.53,0,0,0,14,7,1.55,1.55,0,0,0,13.54,5.88ZM6.25,3.49a.75.75,0,0,1,1.5,0v3a.75.75,0,0,1-1.5,0Zm.75,7a1,1,0,1,1,1-1A1,1,0,0,1,7,10.49Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status-error.1f042e56c387e1010bf7118f126b8f1f.svg";
export { ForwardRef as ReactComponent };